export default theme => ({
    root: {
        margin: theme.spacing(2, 0, 0),
    },
    checked: {
        border: '1px solid transparent',
    },
});
